import React from 'react';
import { ApolloError } from '@apollo/client';
import _ from 'lodash';

import { Typography, CircularProgress } from '@occc/ui-design-system';
import { useAppLayoutContextConsumer, Page } from '@occc-app/design-system';
import { ProductGroupFragment, ProductGroupInput } from '@occc/graphql';

import { UpdateProductGroupForm } from './UpdateProductGroupForm';
import { breadcrumbLinks } from './constants';

const PAGE_TITLE = 'Product Group Update';

type UpdateProductGroupPageProps = {
  loading: boolean;
  error?: ApolloError;
  productGroup?: ProductGroupFragment | null;
  onSubmit: (values: ProductGroupInput) => void;
};

export const UpdateProductGroupPage = ({
  error,
  loading,
  productGroup,
  onSubmit,
}: UpdateProductGroupPageProps) => {
  useAppLayoutContextConsumer(breadcrumbLinks);

  const renderContent = () => {
    if (error) {
      return <Typography color='error'>Something went wrong. Please try again.</Typography>;
    }

    if (loading && !productGroup) {
      return <CircularProgress />;
    }

    if (!productGroup) {
      return (
        <Typography color='error'>No data. Something went wrong. Please try again.</Typography>
      );
    }

    const productGroupValues = _.pick(productGroup, ['name', 'description', 'key', 'values']);
    const initialValues = {
      ...productGroupValues,
      userSelectable: !!productGroup.fuelProductGroup?.userSelectable,
      default: !!productGroup.fuelProductGroup?.default,
      sortingRank: productGroup.fuelProductGroup?.sortingRank,
    };

    return (
      <UpdateProductGroupForm readOnly={false} initialValues={initialValues} onSubmit={onSubmit} />
    );
  };

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{
        title: PAGE_TITLE,
      }}
      containerProps={{ variant: 'md' }}
    >
      {renderContent()}
    </Page>
  );
};
